










































































import Vue from 'vue'

import {
  FindQAQC,
  QAQC,
  QAQCParameter,
  Stack,
  FindQAQCParameters,
  GetStack,
  PatchStack,
} from '@/api/cems'

export default Vue.extend({
  name: 'StackDataLogger',
  data() {
    return {
      optsSharding: [
        { text: '1 hour', value: '1h' },
        { text: '12 hours', value: '12h' },
        { text: '24 hours', value: '24h' },
        { text: '1 week', value: '1w' },
        { text: '30 days', value: '30d' },
      ],
      optsDuration: [
        { text: '1 day', value: '1d' },
        { text: '30 days', value: '30d' },
        { text: '1 week', value: '1w' },
        { text: '4 weeks', value: '4w' },
        { text: '8 weeks', value: '8w' },
        { text: '16 weeks', value: '16w' },
        { text: '32 weeks', value: '32w' },
        { text: '64 weeks', value: '64w' },
        { text: '128 weeks', value: '128w' },
        { text: '256 weeks', value: '256w' },
      ],

      stackUid: '',
      qaqcs: [] as QAQC[],
      stack: { dataLogger: {} } as Stack,
      parameters: [] as QAQCParameter[],
    }
  },
  methods: {
    async getStack() {
      this.stack = await GetStack(this.stackUid)
    },

    async findQAQC() {
      this.qaqcs = await FindQAQC()
    },

    async findParameters(qaqcId: number) {
      this.parameters = await FindQAQCParameters(qaqcId)
    },

    async patchStack() {
      await PatchStack(this.stackUid, this.stack)
      await this.getStack()
    },

    onFormSubmit(e: Event) {
      e.preventDefault()
      this.patchStack()
    },
  },

  watch: {
    'stack.qaqcId': async function(qaqcId: number) {
      await this.findParameters(qaqcId)
    },
  },

  async created() {
    this.stackUid = this.$route.params.stackUID
    await this.findQAQC()
    await this.getStack()
  },
})
